export enum LoadState {
  LOADING,
  SUCCESS,
  ERROR,
}

export interface IAvalancheAdvisoryState {
  readonly data?: IAvalancheData;
  readonly loadState?: LoadState;
}

export interface IAvalancheData {
  danger_scales: Array<IAvalancheDangerScale>;
  forecasts: Array<IAvalancheForecast>;
}

export interface IAvalancheDangerScale {
  danger_id: number;
  level:
    | 'Extreme'
    | 'High'
    | 'Considerable'
    | 'Moderate'
    | 'Low'
    | 'No Rating'
    | 'Insufficient Information'
    | 'Insufficient Snow'
    | 'Centre Closed'
    | 'No Specific Avalanche Type'
    | 'Spring Conditions';
  description: string;
  travel_advice: string;
  likelihood: string | null;
  size: string | null;
}

export interface IAvalancheForecast {
  id: number;
  url: string;
  mountain: string;
  mountain_id: number;
  mountain_lnglat: string;
  issued_at: string;
  valid_to: string;
  high_alpine: number;
  high_alpine_from: number;
  alpine: number;
  alpine_from: number;
  alpine_to: number;
  sub_alpine: number;
  sub_alpine_to: number;
  primary_danger?: string | null;
}
